<template>
  <v-data-table
    :headers="bannerHeaders"
    :items="tenant.banners"
    class="elevation-1 my-7"
    :class="{ 'on-add': onAddingProcess }">
    <template v-slot:top>
      <v-toolbar flat>
        <v-toolbar-title>Banners</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-dialog v-model="dialog" max-width="500px">
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="accent" dark class="mb-2" v-bind="attrs" v-on="on"> New Item</v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="text-h5">{{ editingItem ? "Edit" : "Create New" }} Item</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" sm="12" md="12">
                    <v-select
                      v-model="modalPayload.type"
                      :items="types"
                      :menu-props="{ bottom: true, offsetY: true }"
                      hide-details
                      item-text="text"
                      item-value="value"
                      label="Type"
                      outlined></v-select>
                  </v-col>

                  <v-col cols="12" sm="12" md="12">
                    <v-select
                      v-model="modalPayload.locale"
                      :items="localeOptions"
                      :menu-props="{ bottom: true, offsetY: true }"
                      hide-details
                      item-text="text"
                      item-value="value"
                      label="Language"
                      clearable
                      outlined></v-select>
                  </v-col>

                  <v-col cols="12" sm="12" md="12">
                    <v-text-field
                      hide-details="auto"
                      v-model="modalPayload.imagePath"
                      label="Image Path"
                      outlined></v-text-field>
                  </v-col>

                  <v-col cols="12" sm="12" md="12">
                    <v-text-field hide-details="auto" v-model="modalPayload.link" label="Link" outlined></v-text-field>
                  </v-col>

                  <v-col cols="12" sm="12" md="12">
                    <v-checkbox hide-details v-model="modalPayload.enabled" label="Enabled"></v-checkbox>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions class="pr-8 pb-8">
              <v-spacer></v-spacer>
              <v-btn color="primary" @click="dialog = false"> Cancel</v-btn>
              <v-btn color="accent" @click="handleSave"> Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="deleteDialog" max-width="500px">
          <v-card>
            <v-card-title class="text-h5">Are you sure you want to delete this item?</v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" @click="deleteDialog = false">Cancel</v-btn>
              <v-btn color="accent" @click="confirmDeleteItem">OK</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>
    <template v-slot:[`item.type`]="{ item }">
      {{ typeText(item.type) }}
    </template>
    <template v-slot:[`item.locale`]="{ item }">
      {{ localeText(item.locale) }}
    </template>
    <template v-slot:[`item.enabled`]="{ item }">
      <v-icon small :color="item.enabled ? 'greeny' : 'grey'">
        {{ item.enabled ? "mdi-check-circle" : "mdi-close-circle" }}
      </v-icon>
    </template>
    <template v-slot:[`item.actions`]="{ item }">
      <v-icon small color="third" class="mr-2" @click="editItem(item)"> mdi-pencil</v-icon>
      <v-icon small color="primary" @click="deleteItem(item)"> mdi-delete</v-icon>
    </template>
  </v-data-table>
</template>

<script>
export default {
  name: "Banners",
  props: {
    tenant: {
      type: Object,
      required: true,
    },
    locales: {
      type: Array,
      default: () => [],
    },
    onAddingProcess: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      types: [{ text: "Mobile App", value: "mobile_app" }],
      bannerHeaders: [
        { text: "Type", align: "start", sortable: false, value: "type" },
        { text: "Language", value: "locale" },
        { text: "Image Path", value: "imagePath" },
        { text: "Link", value: "link" },
        { text: "Enabled", value: "enabled" },
        { text: "Actions", value: "actions", sortable: false, align: "right" },
      ],
      modalPayload: {
        type: "mobile_app",
        locale: null,
        imagePath: "",
        link: "",
        enabled: true,
      },
      dialog: false,
      deleteDialog: false,
      itemToDelete: null,
      editingItem: null,
    };
  },
  computed: {
    localeOptions() {
      return [{ text: "All languages", value: null }, ...this.locales];
    },
  },
  watch: {
    dialog(val) {
      if (!val) {
        this.modalPayload = {
          type: "mobile_app",
          locale: null,
          imagePath: "",
          link: "",
          enabled: true,
        };
        this.editingItem = null;
      }
    },
  },
  methods: {
    typeText(value) {
      return this.types.find((type) => type.value === value)?.text || value;
    },
    localeText(value) {
      if (!value) return "All languages";
      return this.locales.find((locale) => locale.value === value)?.text || value;
    },
    handleSave() {
      if (this.editingItem) {
        Object.assign(this.editingItem, {
          type: "mobile_app",
          locale: this.modalPayload.locale,
          imagePath: this.modalPayload.imagePath,
          link: this.modalPayload.link,
          enabled: this.modalPayload.enabled,
        });
      } else {
        this.tenant.banners.push({
          type: "mobile_app",
          locale: this.modalPayload.locale,
          imagePath: this.modalPayload.imagePath,
          link: this.modalPayload.link,
          enabled: this.modalPayload.enabled,
        });
      }
      this.dialog = false;
    },
    deleteItem(item) {
      this.itemToDelete = item;
      this.deleteDialog = true;
    },
    confirmDeleteItem() {
      const index = this.tenant.banners.indexOf(this.itemToDelete);
      if (index > -1) {
        this.tenant.banners.splice(index, 1);
      }
      this.deleteDialog = false;
      this.itemToDelete = null;
    },
    editItem(item) {
      this.modalPayload.type = item.type;
      this.modalPayload.locale = item.locale;
      this.modalPayload.imagePath = item.imagePath;
      this.modalPayload.link = item.link;
      this.modalPayload.enabled = item.enabled;
      this.editingItem = item;
      this.dialog = true;
    },
  },
};
</script>

<style lang="scss" scoped></style>
